export const articleData = {
  'her-secret-life': {
    id: '1',
    title: '她的私密生活',
    author: '金作家',
    category: '恋爱',
    rating: 4.8,
    ratingCount: '32,580',
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%2C%20beautiful%20female%20character%2C%20soft%20pink%20pastel%20background%2C%20warm%20romantic%20atmosphere%2C%20clean%20minimal%20composition%2C%20high%20quality%20digital%20painting%2C%20anime%20inspired%20style%20with%20delicate%20details&width=600&height=850&seq=hanman-article-01&orientation=portrait',
    description: '一场意外让两个原本毫无交集的人走到了一起。她是一个有着不为人知秘密的普通上班族，他是一个看似冷漠实则温柔的公司高管。当他们的秘密互相交织，一段既甜蜜又充满挑战的爱情故事就此展开。',
    longDescription: '《她的私密生活》是韩国漫画家金作家的代表作，讲述了女主角韩智雅和男主角朴泰俊之间跌宕起伏的爱情故事。韩智雅是一名普通的广告公司职员，但她隐藏着一个不为人知的秘密——她是一名网络漫画作者。而朴泰俊是公司的副总裁，外表冷酷、能力出众，但他也有自己的秘密：他其实是韩智雅漫画的忠实读者。当两人的秘密被彼此发现，一场充满误会、欢笑与感动的爱情故事就此展开。本作以细腻的画风和真实的情感描写赢得了大量读者的喜爱，是韩漫恋爱题材中不可多得的佳作。',
    totalChapters: 89,
    views: '1.2亿',
    tags: ['恋爱', '职场', '甜蜜', '治愈', '都市'],
    chapters: [
      { num: 89, title: '意外的告白', date: '2026-07-03' },
      { num: 88, title: '心跳加速的瞬间', date: '2026-06-26' },
      { num: 87, title: '无法隐藏的心意', date: '2026-06-19' },
      { num: 86, title: '深夜的约定', date: '2026-06-12' },
      { num: 85, title: '办公室的秘密', date: '2026-06-05' },
    ],
    relatedComics: [
      { id: 'r1', title: '甜蜜陷阱', coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%2C%20sweet%20couple%20scene%2C%20soft%20peach%20background%2C%20gentle%20atmosphere%2C%20small%20thumbnail%20size%2C%20clean%20composition&width=200&height=280&seq=hanman-rel-01&orientation=portrait', rating: 4.5, slug: 'sweet-trap' },
      { id: 'r2', title: '我的契约男友', coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%2C%20elegant%20couple%2C%20soft%20champagne%20background%2C%20sophisticated%20atmosphere%2C%20small%20thumbnail%2C%20clean%20composition&width=200&height=280&seq=hanman-rel-02&orientation=portrait', rating: 4.4, slug: 'contract-boyfriend' },
      { id: 'r3', title: '春日恋歌', coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%2C%20spring%20cherry%20blossom%20scene%2C%20soft%20pink%20atmosphere%2C%20youthful%20love%2C%20small%20thumbnail%2C%20clean%20composition&width=200&height=280&seq=hanman-rel-03&orientation=portrait', rating: 4.3, slug: 'spring-love-song' },
    ],
    faqs: [
      { question: '《她的私密生活》多久更新一次？', answer: '《她的私密生活》通常每周五更新一话，如遇特殊情况会提前在公告中说明。' },
      { question: '《她的私密生活》一共有多少话？', answer: '本作目前连载至第89话，仍在持续更新中，最终话数暂未确定。' },
      { question: '《她的私密生活》适合什么年龄段的读者？', answer: '本作适合15岁以上的读者观看，内容以甜蜜恋爱为主题，画风清新，情节健康向上。' },
    ],
  },
  'sword-and-magic': {
    id: '2',
    title: '剑与魔法',
    author: '朴大神',
    category: '奇幻',
    rating: 4.9,
    ratingCount: '45,200',
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%2C%20epic%20warrior%20with%20magical%20sword%2C%20mystical%20blue%20green%20atmosphere%2C%20adventure%20theme%2C%20clean%20composition%2C%20high%20quality%20digital%20illustration%2C%20anime%20style%20with%20dramatic%20lighting&width=600&height=850&seq=hanman-article-02&orientation=portrait',
    description: '在剑与魔法交织的世界里，一位平凡少年踏上了成为最强魔法剑士的冒险之旅。从最底层的冒险者开始，凭借着不屈的意志和过人的天赋，他一步步突破极限，挑战最强的敌人。',
    longDescription: '《剑与魔法》是韩国著名漫画家朴大神倾力打造的奇幻冒险巨作。故事发生在一个剑与魔法并存的世界，主角金成浩原本是一个普通村庄的少年，在村庄遭受魔兽袭击后，他决心成为最强的魔法剑士来保护身边的人。他进入魔法学院，结识了一群志同道合的伙伴，共同经历了无数惊险刺激的冒险。从地下迷宫到天空之城，从远古遗迹到魔界深渊，金成浩的冒险永无止境。本作以其宏大的世界观、精彩的战斗场面和深刻的人物刻画，成为韩国奇幻漫画的标杆之作。',
    totalChapters: 156,
    views: '9800万',
    tags: ['奇幻', '冒险', '魔法', '战斗', '成长'],
    chapters: [
      { num: 156, title: '最终试炼的真相', date: '2026-07-02' },
      { num: 155, title: '远古龙族的觉醒', date: '2026-06-25' },
      { num: 154, title: '传说中的圣剑', date: '2026-06-18' },
      { num: 153, title: '伙伴们的决心', date: '2026-06-11' },
      { num: 152, title: '黑暗势力的逼近', date: '2026-06-04' },
    ],
    relatedComics: [
      { id: 'r4', title: '神之塔', coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20tower%20cover%2C%20mysterious%20tower%2C%20epic%20fantasy%2C%20dark%20blue%20gold%20background%2C%20small%20thumbnail%2C%20grand%20composition&width=200&height=280&seq=hanman-rel-04&orientation=portrait', rating: 4.9, slug: 'tower-of-god' },
      { id: 'r5', title: '末日后记', coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20post%20apocalyptic%20cover%2C%20futuristic%20ruins%2C%20dark%20atmospheric%2C%20survival%20theme%2C%20small%20thumbnail%2C%20clean%20composition&width=200&height=280&seq=hanman-rel-05&orientation=portrait', rating: 4.6, slug: 'post-apocalypse' },
      { id: 'r6', title: '暗夜追踪', coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20noir%20cover%2C%20detective%20scene%2C%20dark%20urban%20night%2C%20mysterious%20mood%2C%20small%20thumbnail%2C%20clean%20composition&width=200&height=280&seq=hanman-rel-06&orientation=portrait', rating: 4.7, slug: 'night-tracking' },
    ],
    faqs: [
      { question: '《剑与魔法》的世界观有多宏大？', answer: '《剑与魔法》构建了一个极其宏大的奇幻世界，包含多个大陆、种族和魔法体系，世界观设定深度堪比顶级奇幻小说。' },
      { question: '《剑与魔法》适合新手入门吗？', answer: '非常适合！虽然世界观宏大，但故事从主角的成长经历切入，即使是初次接触奇幻韩漫的读者也能轻松入坑。' },
    ],
  },
};

export const defaultArticle = {
  id: '0',
  title: '韩漫详情',
  author: '未知',
  category: '综合',
  rating: 4.0,
  ratingCount: '0',
  status: '连载中',
  coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20generic%20cover%2C%20beautiful%20character%20illustration%2C%20soft%20neutral%20background%2C%20clean%20minimal%20composition%2C%20high%20quality%20digital%20art%2C%20anime%20style&width=600&height=850&seq=hanman-article-default&orientation=portrait',
  description: '该韩漫正在紧张筹备中，敬请期待...',
  longDescription: '更多详情即将上线，请关注我们的最新动态。',
  totalChapters: 0,
  views: '0',
  tags: [],
  chapters: [],
  relatedComics: [],
  faqs: [],
};